import {
  RType,
  Workload,
  TechDomain,
  AWSService,
  Environment,
  TechDomainDisplayNames,
} from '@amzn/awscat-pattern-library-service-model';
import { FilterCategory, filterOptionToLabelMap } from '../components/content/ContentFilters';
import {
  rTypeDisplayNames,
  workloadDisplayNames,
  awsServiceReadonlyDisplayNames,
  environmentDisplayNames,
} from '../components/utils/DisplayNames';

export enum ContentVisibilitySlicerId {
  Internal = 'home-page-content-visibility-internal-slicer',
  External = 'home-page-content-visibility-external-slicer',
  Public = 'home-page-content-visibility-public-slicer',
}

export enum ContentTypeSlicerId {
  Strategy = 'home-page-content-type-strategy-slicer',
  Guide = 'home-page-content-type-guide-slicer',
  Pattern = 'home-page-content-type-pattern-slicer',
}

export enum ContentSortDropdownId {
  NewToOld = 'home-page-content-sort-newest-to-oldest',
  OldToNew = 'home-page-content-sort-oldest-to-newest',
  AToZ = 'home-page-content-sort-A-to-Z',
  ZToA = 'home-page-content-sort-Z-to-A',
}

export enum CSVDownloadId {
  Pattern = 'csv-download-pattern',
}

export enum AddSuggestedReviewerId {
  AddReviewer = 'add-suggested-reviewer',
}

export const getCssLocator = (label: string, value: string): string => {
  return `[${label}="${value}"]`;
};

// Convert filter label to ids for client side tracking purpose
export const convertFilterLabelToId = (label: string) => {
  if (!label) {
    return '';
  }
  return label.replace(/\s/g, '-');
};

type FilterDisplayType = TechDomain | RType | Workload | AWSService | Environment;
// Convert filter display names to ids for client side tracking purpose
export const convertFiltersToIds = (
  filterCategory: FilterCategory,
  filterDisplayNames: Map<FilterDisplayType, string>,
) => {
  return Array.from(filterDisplayNames.values()).map((filterLabel) => {
    return {
      event: 'click',
      cssLocator: getCssLocator(
        'id',
        `home-page-content-filter-${convertFilterLabelToId(filterOptionToLabelMap.get(filterCategory) ?? '')}-${convertFilterLabelToId(filterLabel)}`,
      ),
    };
  });
};

export const homePageFilterIncludeCode = [
  { event: 'click', cssLocator: getCssLocator('id', 'home-page-content-filter-Code-Include-code') },
];
export const homePageFilterTechDomain = convertFiltersToIds(
  FilterCategory.TechDomains,
  TechDomainDisplayNames,
);
export const homePageFilterRType = convertFiltersToIds(FilterCategory.RType, rTypeDisplayNames);
export const homePageFilterWorkload = convertFiltersToIds(
  FilterCategory.Workload,
  workloadDisplayNames,
);
export const homePageFilterAWSServices = convertFiltersToIds(
  FilterCategory.AwsServices,
  awsServiceReadonlyDisplayNames,
);
export const homePageFilterEnv = convertFiltersToIds(
  FilterCategory.Environment,
  environmentDisplayNames,
);

const contentFilterIds = [
  ...homePageFilterIncludeCode,
  ...homePageFilterTechDomain,
  ...homePageFilterRType,
  ...homePageFilterWorkload,
  ...homePageFilterAWSServices,
  ...homePageFilterEnv,
].map((domEvent) => {
  const cssLocator = domEvent.cssLocator;
  const value = cssLocator.split('="')[1];
  // @ts-expect-error TS18048 - strict migration
  return value.slice(0, value.length - 2);
});

type ContentFilterId = (typeof contentFilterIds)[number];

export type RUMId =
  | ContentVisibilitySlicerId
  | ContentTypeSlicerId
  | ContentSortDropdownId
  | ContentFilterId
  | CSVDownloadId
  | AddSuggestedReviewerId;
